/**
 * Configuração por ambiente
 *
 * Este arquivo define as configurações específicas para cada ambiente
 * baseado em variáveis de ambiente, permitindo flexibilidade total.
 */

export type Environment = 'development' | 'production';

/**
 * Detecta o ambiente atual baseado na variável de ambiente
 */
export const getCurrentEnvironment = (): Environment => {
  const env = import.meta.env.VITE_ENVIRONMENT;

  if (env === 'development' || env === 'dev') {
    return 'development';
  }

  return 'production';
};

/**
 * Configuração unificada baseada em variáveis de ambiente
 */
export const ENVIRONMENT_CONFIG = {
  name: getCurrentEnvironment(),
  apiUrl: import.meta.env.VITE_ORCHESTRATOR_CONSOLE_API_URL || 'http://localhost:8000',
  debug: import.meta.env.VITE_DEBUG === 'true' || getCurrentEnvironment() === 'development',
};

/**
 * Obtém a configuração do ambiente atual
 */
export const getEnvironmentConfig = () => {
  return ENVIRONMENT_CONFIG;
};
